import React from 'react';
import { Shield, Check, X } from 'lucide-react';
export function DurabilitySection() {
  const matters = [{
    title: 'Mix Design',
    desc: 'Proper cement ratio and aggregate selection'
  }, {
    title: 'Air Entrainment',
    desc: 'Microscopic air bubbles that let water expand during freeze without cracking'
  }, {
    title: 'Curing',
    desc: 'Slow, proper curing (not rushed) prevents surface weakness'
  }, {
    title: 'Sealer Strategy',
    desc: 'Right sealer type, applied at right time, reapplied on schedule'
  }, {
    title: 'Drainage',
    desc: 'Water must drain away, not pool on surface'
  }, {
    title: 'Salt Discipline',
    desc: 'Less salt = longer life. Heating helps here.'
  }];
  const mattersLess = [{
    title: "'Premium finish' marketing claims"
  }, {
    title: 'Finish type alone (a well-done broom finish outlasts a poorly done stamped job)'
  }, {
    title: "Color additives (they don't affect structural durability)"
  }];
  return <section className="py-16 bg-white md:py-24" data-id="element-147">
      <div className="container mx-auto px-4 md:px-6" data-id="element-148">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-149">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-150">
            The Truth About Durability
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-151">
            Durability depends more on what is UNDER the finish than the finish
            itself.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-152">
          {/* What Matters */}
          <div className="bg-slate-50 rounded-xl p-8 border border-slate-100" data-id="element-153">
            <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-154">
              <Shield className="h-6 w-6 text-green-600" data-id="element-155" /> What Actually
              Matters
            </h3>
            <ul className="space-y-6" data-id="element-156">
              {matters.map((item, index) => <li key={index} className="flex gap-4" data-id="element-157">
                  <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-158">
                    <Check className="h-4 w-4" data-id="element-159" />
                  </div>
                  <div data-id="element-160">
                    <h4 className="font-bold text-slate-900" data-id="element-161">{item.title}</h4>
                    <p className="text-sm text-slate-600" data-id="element-162">{item.desc}</p>
                  </div>
                </li>)}
            </ul>
          </div>

          {/* What Matters Less */}
          <div className="space-y-8" data-id="element-163">
            <div className="bg-white rounded-xl p-8 border border-slate-200 shadow-sm" data-id="element-164">
              <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-165">
                <X className="h-6 w-6 text-slate-400" data-id="element-166" /> What Matters Less Than
                You Think
              </h3>
              <ul className="space-y-4" data-id="element-167">
                {mattersLess.map((item, index) => <li key={index} className="flex gap-4 items-center" data-id="element-168">
                    <div className="shrink-0 w-6 h-6 rounded-full bg-slate-100 flex items-center justify-center text-slate-400" data-id="element-169">
                      <X className="h-4 w-4" data-id="element-170" />
                    </div>
                    <span className="text-slate-600 font-medium" data-id="element-171">
                      {item.title}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-primary/5 p-6 rounded-xl border border-primary/10" data-id="element-172">
              <p className="text-slate-700 italic font-medium" data-id="element-173">
                "We tell you this because we'd rather you have a $12/sq ft broom
                finish that lasts 30 years than a $25/sq ft stamped job that
                spalls in 3."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}